export default __webpack_public_path__ + "static/media/why_us.1484b928.png";